<template>
	<div :id="'yt-' + id" class="video-wrap">
		<iframe :src="'//www.youtube.com/embed/'+id" frameborder="0" width="640" height="360"></iframe>
	</div>
</template>

<script>

	export default {
		name: "VideoYoutube",
		data() {
			return {
				player : {}
			}
		},
		props:{
			id : {
				type : String,
				required : true
			}
		},
		methods: {
		},
		created () {
		}
	}
</script>

<style scoped>
  .video-wrap iframe {
    position: absolute;
    width: 100%;
    height: 100%;
  }

</style>



// WEBPACK FOOTER //
// src/components/subparts/VideoYoutube.vue